import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    orderId: null,
    fcmToken: null
};
const pushNotificationsSlice = createSlice({
    name: 'pushNotifications',
    initialState: initialState,
    reducers: {
        setPushNotificationsOrderId(state, action) {
            const { orderId } = action.payload;
            state.orderId = orderId;
        },
        setFcmToken(state, action) {
            const { fcmToken } = action.payload;
            state.fcmToken = fcmToken;
        }
    }
});
export const { setPushNotificationsOrderId, setFcmToken } = pushNotificationsSlice.actions;
export const selectPushNotificationOrderId = (state) => state.pushNotifications.orderId;
export const selectFcmToken = (state) => state.pushNotifications.fcmToken;
export const pushNotificationsReducer = pushNotificationsSlice.reducer;
